import { createContext } from "react";
import { IBrodMigdalContext } from "../types/brodMigdalContext";

export const BrodMigdalContext = createContext<IBrodMigdalContext | undefined>(undefined);